var angular = require('angular');
var _module = angular.module('benoit');
var $ = require('jquery');
var _ = require('lodash');

require('./_styles.scss');
require('angular-material');
require('angular-ui-router');
require('../user-menu');
require('../../services/user');
require('../../services/lr-touch');
require('../../services/branded-nav');

_module.requires.push(
    'ngMaterial',
    'ui.router'
);

_module.controller('LRHeaderBrandedCtrl', [
    '$log',
    '$user',
    '$mdSidenav',
    '$state',
    '$brandedNav',

    function HeaderBrandedCtrl($log, $user, $mdSidenav, $state, $brandedNav) {
        $log.debug('LRHeaderBrandedCtrl', this);

        var vm = this;
        vm.model = {
            logo: $user.affiliate.branding || _.get($user.affiliate, 'vendor.logo'),
            user: $user,
            agentNavs: $brandedNav.agentNavsGrouped,
            vendorNavs: $brandedNav.vendorNavsGrouped,
            brandedNav: $brandedNav
        };
        vm.events = {
            onHamburgerMenuClick: toggleSideMenu,
            onMenuItemClick: onMenuItemClick
        };
        vm.services = {
            slidePageTo: slidePageTo
        };

        // Functions
        function slidePageTo(id) {
            $('html, body').animate({
                scrollTop: $(id).offset().top
            }, 500);
        }

        function toggleSideMenu() {
            $mdSidenav('brandedsidenav').toggle();
        }

        function onMenuItemClick(nav) {
            var action = nav.action;

            if(!action) return;

            if(action === 'url') {
                if(nav.content.target === '_blank') {
                    window.open(nav.content.url);
                } else {
                    window.location.href = nav.content.url;
                }
            } else {
                $state.go('branded-nav-pages', { pageId: nav.id, slug: nav.content.slug });
            }
        }
    }
]);

_module.component('lrheaderBranded', {
    controllerAs: 'vm',
    controller: 'LRHeaderBrandedCtrl',
    template: require('./index.html')
});
